import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SheetTemplate } from '../types/sheet.types';

@Injectable({
	providedIn: 'root'
})
export class SheetTemplatesService {

	constructor(private httpClient: HttpClient) {
	}

	createFromSheet(sheetId: string, templateName: string) {
		return this.httpClient.post<SheetTemplate>('/api/sheet-templates', { sheetId, templateName });
	}

	updateName(templateId: string, name: string) {
		return this.httpClient.put<SheetTemplate>(`/api/sheet-templates/${templateId}/name`, { templateName: name });
	}

	updateActiveState(templateId: string, isActive: boolean) {
		return this.httpClient.put<SheetTemplate>(`/api/sheet-templates/${templateId}/active`, { isActive });
	}

	deleteTemplate(templateId: string) {
		return this.httpClient.delete<void>(`/api/sheet-templates/${templateId}`);
	}

	getTemplates() {
		return this.httpClient.get<SheetTemplate[]>('/api/sheet-templates');
	}
}
